import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';
import RssFeedIcon from '@mui/icons-material/RssFeed';
import MonitorOutlinedIcon from '@mui/icons-material/MonitorOutlined';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';

const ConvenienceData = [
    {
        icon: <TwoWheelerIcon/>,
        title: "Free Parking",
    },
    {
        icon: <RssFeedIcon/>,
        title: "Free Wifi",
    },
    {
        icon: <MonitorOutlinedIcon/>,
        title: "View and experience the product for free",
    },
    {
        icon: <ForumOutlinedIcon/>,
        title: "Get in-depth advice on products and services",
    },
    {
        icon: <GppGoodOutlinedIcon/>,
        title: "100% genuine product",
    },
    {
        icon: <MonetizationOnOutlinedIcon/>,
        title: "Installment payment policy",
    },
    {
        icon: <PaymentOutlinedIcon/>,
        title: "Easy payment",
    },
    {
        icon: <LocalShippingOutlinedIcon/>,
        title: "Home delivery",
    },
]

export default ConvenienceData;